import React from 'react';

import { useConverters } from './../../pm-converters/context';
import type { AppEmbedNode } from './../../ricos-schema/next-schema';
import type { PluginProps } from './../../ricos-types';

import { VerticalEmbedViewer } from '../viewer/vertical-embed-viewer';

export const AppEmbed: React.FC<PluginProps> = ({ settings, node }) => {
  const converters = useConverters();
  const ricosNode = converters.fromPmNode(node.toJSON()) as AppEmbedNode;
  return (
    <div>
      <VerticalEmbedViewer
        nodeId={node.attrs.id}
        componentData={ricosNode.appEmbedData}
        settings={settings}
        helpers={{}}
      />
    </div>
  );
};
